import React from "react";
import {ReactComponent as ExpandLessDoubleIcon} from "../CommonSportDisplay/icons/expand_less_double.svg";
import {ReactComponent as ExpandLessIcon} from "../CommonSportDisplay/icons/expand_less.svg";
import {ReactComponent as ExpandMoreDoubleIcon} from "../CommonSportDisplay/icons/expand_more_double.svg";
import {ReactComponent as ExpandMoreIcon} from "../CommonSportDisplay/icons/expand_more.svg";


type MoreLessToggleProps = {
    isOpen: boolean;
    doubleArrow?: boolean;
};

export function MoreLessToggle(props: MoreLessToggleProps) {
    return (
        <>
            {props.isOpen ? (
                props.doubleArrow ? (
                    <ExpandLessDoubleIcon/>
                ) : (
                    <ExpandLessIcon/>
                )
            ) : props.doubleArrow ? (
                <ExpandMoreDoubleIcon/>
            ) : (
                <ExpandMoreIcon/>
            )}
        </>
    )

}